import request from '../utils/request'

export function branchOfficeRequest(data) {
    return request({
        url: 'dashboard/statistics/pventas',
        method: 'post',
        data
    })
}


export function productsRequest(data) {
    return request({
        url: 'dashboard/products',
        method: 'post',
        data
    })
}
